import React from "react";
import { motion } from "framer-motion";
import { projekte } from "../../helper/data";

const EngagementGlobalDetails = () => {
  const engagementHarmonieProject = projekte.find(
    (project) => project.titel === "Engagement Global",
  );

  if (!engagementHarmonieProject) {
    return <p>Projekt nicht gefunden.</p>;
  }
  return (
    <div className="container my-4 text-center">
      <motion.div
        className="announcement bg-light p-4 p-md-5 rounded shadow text-start responsive-fs"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img
          src="/images/projekte/engagement/teefarm-map-1974699.png"
          alt="Demokratie"
          className="img-fluid rounded mb-3"
        />
        <div>
          <strong>Projekt:</strong> {engagementHarmonieProject.desc}
        </div>

        <div>
          <strong>Durchführungszeitraum:</strong>{" "}
          {engagementHarmonieProject.time}
        </div>

        <div className="mt-3">
          <h5>Beschreibung</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc1,
            }}
          ></p>
          <h5>Ziele</h5>
          <p className="justify-text">{engagementHarmonieProject.desc2}</p>
          <h5>Ablauf</h5>
          <p className="justify-text">{engagementHarmonieProject.desc3}</p>
          <h5>{engagementHarmonieProject.time2}</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc4,
            }}
          ></p>
          <h5>{engagementHarmonieProject.time3}</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc5,
            }}
          ></p>
          <h5>{engagementHarmonieProject.time4}</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc6,
            }}
          ></p>
          <h5>{engagementHarmonieProject.time5}</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc7,
            }}
          ></p>
          <h5>{engagementHarmonieProject.time6}</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc8,
            }}
          ></p>
          <h5>{engagementHarmonieProject.time7}</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc9,
            }}
          ></p>
          <h5>Förderung</h5>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc10,
            }}
          ></p>
          <h5>Hinweis</h5>
          <span className="fw-bold">Verantwortlich: Harmonie e.V.</span>
          <p
            className="justify-text"
            dangerouslySetInnerHTML={{
              __html: engagementHarmonieProject.desc11,
            }}
          ></p>
        </div>
        <div className="mt-5">
          <img
            src="/images/projekte/engagement/engagementGlobale.jpg"
            alt="EngagementGlobale"
            className="w-100"
          />
        </div>
      </motion.div>
    </div>
  );
};

export default EngagementGlobalDetails;
